import { ReactNode } from "react";
import { Button } from "react-aria-components";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
import ChevronDown from "../../../img/icons/chevron-down.svg?react";
import Reset from "../../../img/icons/reset.svg?react";
import { chevronStyles, chipLabelStyles, filterChip } from "../chipStyles.css";

interface FilterOption {
  label: string;
  value: string;
}

interface IFilterChip {
  label: string;
  icon?: ReactNode;
  selectedOption?: FilterOption[];
  onClick?: () => void;
  /**
   * Whether the filter is a single selection or reset button
   * @default "single"
   */
  mode?: "single" | "reset";
  isDisabled?: boolean;
  isModified?: boolean;
}

const FilterChip = ({
  label,
  selectedOption = [],
  mode = "single",
  onClick = () => {},
  isDisabled,
  isModified,
  icon,
}: IFilterChip) => {
  const { filterChip: defaults } = usePlosTranslations();
  const hasSelectedOptions = selectedOption.length > 0;

  const chipText = hasSelectedOptions ? selectedOption[0].label : label;

  const ariaLabel =
    mode === "reset"
      ? defaults.reset
      : hasSelectedOptions
        ? defaults.selected(label, chipText)
        : defaults.noneSelected(label);

  return (
    <Button
      aria-label={ariaLabel}
      className={filterChip({ isModified })}
      onPress={onClick}
      isDisabled={isDisabled}
    >
      <span className={chipLabelStyles}>
        {icon}
        {chipText}
      </span>
      {mode === "reset" ? (
        <Reset aria-hidden="true" height={18} width={18} />
      ) : (
        <ChevronDown
          className={chevronStyles}
          aria-hidden="true"
          height={18}
          width={18}
        />
      )}
    </Button>
  );
};

export default FilterChip;
